import Vue from 'vue'

import { Upload } from 'iview';
Vue.component('Upload', Upload);

import MaskedInput from 'vue-text-mask'
Vue.component('masked-input', MaskedInput);
